import {
  AccountRawData,
  ActionsThresholds,
  AssociatedKey,
  getAssociatedKeysFromAccountRawData,
} from '@block-explorer/entities';
import { deriveSplitDataFromNamedKeyValue } from '../domain';
import { NamedKeyPrefix } from '@make-software/cspr-design';

type GetAssociatedKeysData = {
  allAccountAssociatedKeys: AssociatedKey[] | null;
  filteredAssociatedKeys: AssociatedKey[] | null;
  actionThresholds: ActionsThresholds | undefined;
};

const useGetAssociatedKeysData = (
  accountRawData: AccountRawData | null,
  accountHash: string | null
): GetAssociatedKeysData => {
  const allAccountAssociatedKeys =
    getAssociatedKeysFromAccountRawData(accountRawData);

  const associatedKeysWithoutCurrentAcc =
    allAccountAssociatedKeys &&
    allAccountAssociatedKeys.filter((key) => {
      const { hash: hashWithoutPrefix } = deriveSplitDataFromNamedKeyValue(
        key.account_hash
      );
      return hashWithoutPrefix !== accountHash;
    });

  const currentAccAssociatedKey =
    allAccountAssociatedKeys &&
    allAccountAssociatedKeys.filter((key) => {
      const { hash: hashWithoutPrefix } = deriveSplitDataFromNamedKeyValue(
        key.account_hash
      );
      return hashWithoutPrefix === accountHash;
    })[0];

  const actionThresholds = accountRawData?.Account?.action_thresholds;

  const hasNonDefaultThresholdSettings =
    actionThresholds &&
    (actionThresholds?.deployment > 1 || actionThresholds?.key_management > 1);

  const hasNonDefaultKeysSettings =
    associatedKeysWithoutCurrentAcc?.length > 0 ||
    currentAccAssociatedKey?.weight > 1;

  const sortedAssociatedKeys = allAccountAssociatedKeys
    ? allAccountAssociatedKeys.sort((a, b) =>
        a.account_hash === `${NamedKeyPrefix.ACCOUNT_HASH}${accountHash}`
          ? -1
          : 1
      )
    : null;

  const filteredAssociatedKeys =
    hasNonDefaultThresholdSettings || hasNonDefaultKeysSettings
      ? sortedAssociatedKeys
      : associatedKeysWithoutCurrentAcc;

  return {
    allAccountAssociatedKeys,
    filteredAssociatedKeys,
    actionThresholds,
  };
};

export default useGetAssociatedKeysData;
